import React from "react";
import "./contactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-us">
      <div className="contact-us-container ">
        <div className="row g-5">
          <div className="col-lg-6">
            <div className="contact-us-right">
              <div className="contact-headline">
                <h2>تواصل معنا</h2>
              </div>
              <div className="sub-box">
                <div className="svg-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="34"
                    viewBox="0 0 40 34"
                    fill="none"
                  >
                    <path
                      d="M29.5 32.1998H10.5C4.8 32.1998 1 29.5175 1 23.2586V10.741C1 4.48216 4.8 1.7998 10.5 1.7998H29.5C35.2 1.7998 39 4.48216 39 10.741V23.2586C39 29.5175 35.2 32.1998 29.5 32.1998Z"
                      stroke="url(#paint0_linear_30426_6098)"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M31.9632 8.70898L21.5846 16.2642C20.2369 17.2451 18.3562 17.2451 17.0085 16.2642L6.62988 8.70898"
                      stroke="url(#paint1_linear_30426_6098)"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_30426_6098"
                        x1="39"
                        y1="7.20425"
                        x2="6.32764"
                        y2="10.6636"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_30426_6098"
                        x1="31.9632"
                        y1="10.1829"
                        x2="11.3203"
                        y2="15.5257"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="text-box">
                  <p>generalhome.roxel@gmail.com</p>
                </div>
              </div>
              <div className="sub-box">
                <div className="svg-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <path
                      d="M30.4281 29.1383L29.5316 30.0515C29.5316 30.0515 27.4007 32.2226 21.5846 26.2966C15.7684 20.3709 17.8992 18.1999 17.8992 18.1999L18.4637 17.6247C19.8545 16.2078 19.9856 13.933 18.7721 12.2723L16.2903 8.87517C14.7885 6.81972 11.8867 6.5482 10.1655 8.3019L7.07609 11.4495C6.22261 12.3191 5.65068 13.4463 5.72004 14.6968C5.89748 17.8959 7.31003 24.779 15.1922 32.8097C23.5508 41.3259 31.3937 41.6643 34.601 41.358C35.6154 41.2612 36.4976 40.7318 37.2085 40.0073L40.0046 37.1588C41.892 35.2358 41.3598 31.9391 38.9449 30.5941L35.1846 28.4994C33.599 27.6162 31.6673 27.8756 30.4281 29.1383Z"
                      stroke="url(#paint0_linear_30426_6167)"
                      stroke-width="2"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_30426_6167"
                        x1="41.1429"
                        y1="13.2378"
                        x2="10.5742"
                        y2="15.9135"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="text-box mob-numbers d-flex">
                  <p>0555133968</p>
                  <p> - </p>
                  <p>0555133795</p>
                </div>
              </div>
              <div className="sub-box">
                <div className="svg-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="37"
                    viewBox="0 0 30 37"
                    fill="none"
                  >
                    <path
                      d="M15.0001 34.9732C21.7534 28.4123 28.5066 22.5375 28.5066 15.2906C28.5066 8.04373 22.4596 2.16895 15.0001 2.16895C7.54072 2.16895 1.49365 8.04373 1.49365 15.2906C1.49365 22.5375 8.2469 28.4123 15.0001 34.9732Z"
                      stroke="url(#paint0_linear_30426_5177)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.765 21.3862C18.2678 21.3862 21.1072 18.5603 21.1072 15.0742C21.1072 11.5882 18.2678 8.76221 14.765 8.76221C11.2622 8.76221 8.42285 11.5882 8.42285 15.0742C8.42285 18.5603 11.2622 21.3862 14.765 21.3862Z"
                      stroke="url(#paint1_linear_30426_5177)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_30426_5177"
                        x1="28.5066"
                        y1="8.00081"
                        x2="5.13423"
                        y2="9.63107"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_30426_5177"
                        x1="21.1072"
                        y1="11.0065"
                        x2="10.1583"
                        y2="11.9383"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="text-box">
                  <p>
                    Prince Saad Ibn Abdulrahman Al Awal Rd, Ar Rawabi, Riyadh
                    14215, Saudi Arabia
                  </p>
                </div>
              </div>
              <div className="sub-box">
                <div className="svg-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M16.0002 30.8569C24.2056 30.8569 30.8574 24.2052 30.8574 15.9997C30.8574 7.79435 24.2056 1.14258 16.0002 1.14258C7.79484 1.14258 1.14307 7.79435 1.14307 15.9997C1.14307 24.2052 7.79484 30.8569 16.0002 30.8569Z"
                      stroke="url(#paint0_linear_30426_6216)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.874 9.88184V16.8734"
                      stroke="url(#paint1_linear_30426_6216)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22.1177 22.1177L16.874 16.874"
                      stroke="url(#paint2_linear_30426_6216)"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_30426_6216"
                        x1="30.8574"
                        y1="6.42512"
                        x2="5.20666"
                        y2="8.59787"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_30426_6216"
                        x1="17.874"
                        y1="11.1248"
                        x2="17.0047"
                        y2="11.1353"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_30426_6216"
                        x1="22.1177"
                        y1="17.8062"
                        x2="17.5911"
                        y2="18.1897"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#132239" />
                        <stop offset="1" stopColor="#0D9AE1" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="text-box">
                  <p>Friday</p>
                  <p className="time">4 - 09:30 PM</p>
                  <p>From Saturday to Thursday</p>
                  <p className="time">8 - 11:30 AM — 4 - 09:30 PM </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact-us-left">
              <iframe
                title="name"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3625.328844152613!2d46.7788850757143!3d24.68121997804666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0714caebcd8b%3A0x37e1cecf55f725b9!2z2YXYpNiz2LPYqSDYp9mE2YrYrdmKINmE2YTZhdmD2YrZgdin2Kog2KfZhNi12K3Ysdin2YjZitip!5e0!3m2!1sen!2seg!4v1752191926914!5m2!1sen!2seg"
                width="100%"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
